import cc from "classcat"
import { ComponentType, lazy, Suspense } from "react"

interface Props {
  name: string
  className?: string
  fill?: boolean
  stroke?: number
  title?: string
}

interface SVGProps {
  title: string
  strokeWidth: number
  fill: string
  role: string
}

export const Icon = ({
  name,
  className,
  fill = true,
  stroke = 0,
  title,
}: Props) => {
  const Svg = lazy<ComponentType<SVGProps>>(() =>
    import(`../svg/${name}.svg`).then((mod) => ({
      default: mod.ReactComponent,
    }))
  )

  const classes = cc(["icon", `icon--${name}`, className])

  return (
    <span className={classes}>
      <Suspense fallback={null}>
        <Svg
          title={title || `${name.replace(/[_-]/g, " ")} icon`}
          strokeWidth={stroke}
          fill={fill ? "currentColor" : "none"}
          role="img"
        />
      </Suspense>
    </span>
  )
}
